import React, { Component } from "react";
import { deleteLocationMap, editLocationMap } from "LocationMapActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showError, showSuccess } from "ReduxErrorBar";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import {
  ACCESS_FILES_API_KEY,
  BASE_IMAGES_URL,
  IMAGE_PATH,
  INSTANCE_URL,
  COMMON_FAIL_MESSAGE,
} from "Constants";
import {
  openInteractiveMap,
  deleteInteractiveMap,
  openiMapModal,
} from "InteractiveMapAction";
import { checkContentDashboardStatus } from "GeneralTabAction";
import LocaleStrings from "Languages";
class LocationMapItem extends Component {
  constructor(props) {
    super(props);
  }

  onEditLocationMap = () => {
    if (this.props.is_locationmap) {
      this.props.actions.editLocationMap(this.props.locationmap);
    } else {
      this.props.actions.openInteractiveMap(this.props.locationmap);
      this.props.actions.openiMapModal(true);
    }
  };

  onDeleteLocationMap = () => {
    confirmAlert({
      title: "Delete",
      message: "This will permanently delete the Map. Continue?",
      confirmLabel: "OK",
      cancelLabel: "CANCEL",
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            if (this.props.is_locationmap) {
              this.props.actions.deleteLocationMap(
                this.props.session,
                this.props.locationmap,
                (result) => {
                  if (result.error) {
                    this.props.actions.showError(COMMON_FAIL_MESSAGE);
                  } else {
                    this.props.actions.showSuccess("Map deleted successfully!");
                    this.props.actions.checkContentDashboardStatus(
                      this.props.session
                    );
                  }
                }
              );
            } else {
              this.props.actions.deleteInteractiveMap(
                this.props.session,
                this.props.locationmap.interactivemapid,
                (result) => {
                  if (result.error) {
                    this.props.actions.showError(COMMON_FAIL_MESSAGE);
                  } else {
                    this.props.actions.showSuccess("Map deleted successfully!");
                    this.props.actions.checkContentDashboardStatus(
                      this.props.session
                    );
                  }
                }
              );
            }
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    var { locationmap, is_locationmap } = this.props;
    var imageurl = "";
    var mapname = "";
    var key = "";

    if (is_locationmap) {
      imageurl = `${BASE_IMAGES_URL}/${locationmap.thumbimagepath}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      mapname = locationmap.name;
      key = locationmap.mapid;
    } else {
      if (locationmap.thumbfilepath === "")
        imageurl = "../../style/images/no-map-image.png";
      else
        imageurl = `${BASE_IMAGES_URL}/${locationmap.thumbfilepath}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      mapname = locationmap.mapname;
      key = locationmap.interactivemapid;
    }

    var mapStyle = {
      cursor: "pointer",
      overflow: "hidden",
      padding: "5px",
      // width: '214px'
      width: "112px",
    };

    var style = {
      top: "7px",
      position: "absolute",
      // right: '25px',
      left: "25%",
      cursor: "pointer",
    };

    var itemStyle = {
      borderRadius: "5px",
      float: "right",
      height: "100px",
      width: "100px",
      objectFit: "cover",
    };

    var textstyle = {
      marginTop: "210px",
      marginLeft: "5px",
    };

    return (
      <div>
        <div key={key} className="action-button-area">
          <div className="action-button vcenter">
            <button
              className="btn btn-custom-table-white"
              onClick={this.onEditLocationMap}
            >
              {LocaleStrings.button_edit}
            </button>
          </div>
          <div className="action-button vcenter">
            <button
              className="i-custom-table-delete"
              onClick={this.onDeleteLocationMap}
            >
              <img
                className="button-delete-icon"
                src="../../style/images/delete.png"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

var mapStateToProps = (state) => ({
  session: state.session,
});

var bindActionsToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      deleteLocationMap,
      showError,
      showSuccess,
      editLocationMap,
      openInteractiveMap,
      deleteInteractiveMap,
      openiMapModal,
      checkContentDashboardStatus,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, bindActionsToProps)(LocationMapItem);
